import React from 'react';
import { getIconUrl } from '../utils';

export const Icons = {
  ADD: {
    GREY: 'add_grey',
    RED: 'add_red',
  },
  ADD_PHOTO: { GREY: 'camera-add-photo_grey' },
  ADD_TO_CALENDAR: {
    DEFAULT: 'add-to-calendar_default',
    RED: 'add-to-calendar_red',
  },
  ARROW_LEFT: {
    DEFAULT: 'arrow-left_red2',
    RED: 'arrow-left_red2',
    BLACK: 'arrow-left_black',
    GREY: 'arrow-left_grey',
  },
  ARROW_RIGHT: {
    DEFAULT: 'arrow-right_red',
    RED: 'arrow-right_red',
    WHITE: 'arrow-right_white',
  },
  AVATAR: { DEFAULT: 'avatar_default' },
  BELL: { BLACK: 'bell_black' },
  BLOG: 'blog-grey',
  CALENDAR: { DEFAULT: 'calendar_default', RED: 'calendar2_red' },
  CALENDAR_CLOCK: 'calendarclock',
  CAMERA: { GREY: 'camera-icon_grey' },
  CARET_DOWN: { GREY: 'caret-down_grey' },
  CARET_LEFT: { WHITE: 'caret-left_white' },
  CARET_RIGHT: {
    GREY: 'caret-right_grey',
    RED: 'caret-right_red',
    WHITE: 'caret-right_white',
  },
  CHALLENGE_AWARDS: { BADGE: 'challenge-awards-badge' },
  CIRCLED_CHECKMARK: { BLACK: 'circled-checkmark_black' },
  CLIPBOARD: { DEFAULT: 'clipboard_default' },
  COMMENT: { FILLED: 'comment_filled', GREY: 'comment_grey' },
  COMPASS: { RED: 'compass_red' },
  COPY_LINK: { BLACK: 'copy-link_black' },
  COURSE_ROUTE: { DEFAULT: 'course-route_default' },
  CROSS: {
    WHITE: 'np-cross_white',
    GREY: 'np-cross_grey',
    BLACK: 'np-cross_black',
    THIN_BLACK: 'cross-thin_black',
    THIN_RED: 'cross-thin_red',
    THICK_RED: 'cross-thick_red',
  },
  CROWD: { DEFAULT: 'crowd_default' },
  CROWD_TRIO: { DEFAULT: 'crowdtrio_default' },
  DIRECTIONS: { DEFAULT: 'directions_default' },
  FACEBOOK: 'facebook-white',
  FAQ: { DEFAULT: 'faq_default' },
  FINISH_BANNER: 'finish-banner',
  FINISH_LINE: 'finish-line',
  GOOGLE: { DEFAULT: 'google_default' },
  GRID_VIEW: {
    ACTIVE: 'grid-view_active',
    INACTIVE: 'grid-view_inactive',
  },
  HANDBOOK: { DEFAULT: 'handbook_default' },
  HIGH_FIVE: {
    ACTIVE: 'high-five_active',
    GREY: 'high-five_grey',
    BLUE: 'high-five_blue',
  },
  INSTAGRAM: { WHITE: 'instagram-white', GREY: 'instagram-grey' },
  KIT_LIST: { DEFAULT: 'kit-list_default' },
  LIGHTNING: {
    DEFAULT: 'lightning_default',
    GREEN: 'lightning_green',
    GREY: 'lightning_grey',
    RED: 'lightning_red',
  },
  LIST_VIEW: {
    ACTIVE: 'gallery-view_active',
    INACTIVE: 'gallery-view_inactive',
  },
  LOCATION_ARROW: { RED: 'location-arrow_red' },
  LOCATION_PIN: { GREY: 'location-pin_grey' },
  LOCATION_WIRE: { BLACK: 'location-wire_black', RED: 'location-wire_red' },
  MEDAL: { DEFAULT: 'medal', BLUE: 'medal_blue' },
  PHOTO: { BLUE: 'photo_blue' },
  PENCIL: { BLACK: 'pencil_black', RED: 'pencil_red' },
  PASSWORD: 'password',
  RACEDAY: { DEFAULT: 'raceday_default' },
  RACEDAY_LOGISTICS: { DEFAULT: 'raceday-logistics_default' },
  REGISTRATION_INFO: { DEFAULT: 'registration-info_default' },
  RESULT_VERIFIED: 'result-verified',
  ROAD: { DEFAULT: 'road', BLUE: 'road_blue' },
  SEARCH: { BLACK: 'search_black', RED: 'search_red' },
  SETTINGS: { BLACK: 'settings_black' },
  SHARE: { RED: 'share_red' },
  SHOE: 'shoe',
  SMART_WATCH: { DEFAULT: 'SmartWatch', BLUE: 'SmartWatch_blue' },
  STAR: { YELLOW: 'rating_yellow' },
  STORE: 'store-grey',
  STRAVA: { WHITE: 'strava-white', GREY: 'strava-grey' },
  UNDERSCORE: { DEFAULT: 'underscore' },
  TICKET: { DEFAULT: 'ticket_default' },
  TICK: { GREEN: 'tick_green' },
  TICKETS: { DEFAULT: 'tickets_default' },
  TIMER: { DEFAULT: 'timer_default' },
  TRASH_CAN: { BLACK: 'trash-can_black', RED: 'trash-can_red' },
  TREADMILL: { BLUE: 'treadmill_blue' },
  TROPHY: { GREY: 'trophy_grey' },
  TWITTER: 'twitter',
  VIDEO: { GREY: 'video-icon_grey' },
  // Weather keys from DarkSky possible icons.
  WEATHER: {
    'clear-day': 'weather/Sun',
    'clear-night': 'weather/Moon',
    rain: 'weather/Cloud-Drizzle',
    snow: 'weather/Cloud-Snow',
    sleet: 'weather/Cloud-Hail',
    wind: 'weather/Wind',
    fog: 'weather/Cloud-Fog-Alt',
    cloudy: 'weather/Cloud',
    'partly-cloudy-day': 'weather/Cloud-Sun',
    'partly-cloudy-night': 'weather/Cloud-Moon',
    default: 'weather/Moon-Full',
  },
  MAP: {
    RED: 'map_red',
  },
  BIKE: 'bike-icon',
  RUN: 'run-icon',
  SWIM: 'swim',
};

const Icon = ({ icon, ...otherProps }: any) => {
  const [file, extension] = (icon || '').split('.');
  const [name, color] = file.split('_');

  return (
    <img
      src={getIconUrl({
        name,
        color,
        ...(extension ? { extension } : {}),
      })}
      alt="Icon"
      {...otherProps}
    />
  );
};

export default Icon;
